import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-tooltip-content',
    templateUrl: './tooltip-content.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./tooltip-content.component.scss']
})
export class TooltipContentComponent {
    tooltipText = input<SafeHtml | undefined>('');
}
